import {dark} from './dark';
import {fontSize} from '../core/fontSize.style';
import {colors} from '../core/light.color.style';
import {padding} from '../core/padding.style';

const templateTheme = {
  preferences: {
    template: 'light',
    menuPage: {
      showMobileMenuName: true
    }
  },
  secondaryColor: colors.C1,
  tertiaryColor: colors.C3,
  quaternaryColor: colors.C3a,
  secondaryBgColor: colors.BC6,
  quinaryBackground: colors.C7,
  textColor: colors.C5,
  iconColor: colors.C6,
  openingTimeBgColor: colors.BC7,
  disabledButtonBackground: colors.C3a,
  disabledButtonHoverBackground: colors.C10,
  disabledTextColor: colors.C10,
  primaryFontFamily: 'Montserrat, sans-serif',

  loading: {
    light: colors.C1,
    dark: colors.C2
  },

  // Container sizes
  container: {
    wider: {
      width: '114rem',
      margin: '1.6rem auto'
    },
    wide: {
      width: 'auto',
      margin: '1.2rem'
    },
    desktop: {
      width: 'auto'
    },
    tablet: {
      width: 'auto'
    },
    phone: {
      width: 'auto',
      margin: 0
    }
  },

  h1: {
    large: {
      fontSize: fontSize.size50,
      lineHeight: '5rem'
    },
    medium: {
      fontSize: fontSize.size40,
      lineHeight: '4rem'
    },
    small: {
      fontSize: fontSize.size36,
      lineHeight: '3.6rem'
    }
  },

  basketModal: {
    padding: padding.padding24,
    borderColor: colors.BD3,
    content: {
      maxHeight: 'calc(100vh - 20rem)'
    },
    footer: {
      backgroundColor: colors.BC11
    }
  },

  basketItem: {
    background: colors.BC1,
    lineHeight: '1.8rem',
    width: {
      desktop: '70rem',
      tablet: '54rem',
      phone: '100%'
    },
    text: {
      fontSize: fontSize.size22,
      fontWeight: 'bold'
    },
    subtitle: {
      textAlign: 'center',
      transform: 'uppercase'
    },
    description: {
      fontSize: fontSize.size14,
      color: colors.C9
    },
    size: {
      fontSize: fontSize.size14,
      color: colors.C10
    },
    selected: {
      color: colors.C1,
      backgroundImage: 'none',
      backgroundColor: colors.C8,
      boxShadow: 'none'
    },
    optionsGroup: {
      fontSize: fontSize.size18,
      color: colors.C10,
      lineHeight: '4.4rem',
      backgroundColor: 'none',
      boxShadow: 'none',
      textAlign: 'center'
    },
    comment: {
      backgroundColor: colors.BC10,
      height: '7rem'
    },
    optionsGroupInfo: {
      fontSize: fontSize.size14,
      color: colors.C2a
    },
    option: {
      lineHeight: '4.4rem',
      display: 'none',
      fontSize: fontSize.size14,
      padding: padding.padding10,
      borderRadius: '0.2rem',
      margin: '0.5rem 1rem',
      backgroundImage: 'linear-gradient(to bottom, #dcdcd7, #e4e4df)',
      boxShadow: 'none',
      backgroundColor: colors.BC6
    },
    quantity: {
      block: {
        size: '4.4rem'
      },
      fontSize: fontSize.size20,
      color: colors.C1,
      hoverColor: colors.C2,
      width: '13.2rem'
    }
  },
  sideBasket: {
    backgroundColor: colors.BC7,
    color: colors.C4,
    margin: '5rem 0 auto',
    option: {
      fontFamily: 'Montserrat, sans-serif',
      fontWeight: 700,
      fontSize: fontSize.size12,
      color: colors.C9,
      lineHeight: '1.8rem',
      margin: '2rem'
    },
    item: {
      margin: '1rem 0',
      padding: 0,
      fontSize: fontSize.size14
    },
    special: {
      fontFamily: 'Montserrat, sans-serif',
      fontSize: '1rem',
      letterSpacing: '0.1rem',
      textTransform: 'uppercase'
    },
    header: {
      backgroundColor: 'transparent',
      fontSize: fontSize.size20,
      color: colors.C2,
      borderTop: `${colors.BC11} solid 2.2rem`,
      borderRight: `${colors.BC11} solid 2.2rem`,
      borderBottom: 0
    },
    toggle: {
      size: '4rem',
      cartSize: fontSize.size20,
      arrowSize: fontSize.size14
    },
    closedBackground: colors.C3,
    comments: {
      color: colors.C10
    },
    plusMinus: {
      position: 'absolute',
      display: 'flex',
      top: '3rem'
    },
    dineIn: {
      padding: {
        mobile: '0 0.4rem'
      },
      message: {
        fontSize: fontSize.size16,
        color: colors.BC10
      },
      link: {
        fontSize: fontSize.size12,
        color: colors.C4a
      }
    },
    summary: {
      backgroundColor: colors.BC11,
      padding: 0,
      borderRight: `${colors.BC11} solid 2.2rem`,
      message: {
        padding: '0 1.2rem',
        fontSize: fontSize.size14
      },
      fee: {
        fontWeight: 'normal',
        fontSize: fontSize.size16
      }
    },
    paymentIcon: {
      paddingLeft: padding.padding12,
      paddingRight: padding.padding12,
      paddingBottom: padding.padding06
    },
    message: colors.C11,
    serviceType: {
      padding: padding.padding12
    },
    serviceTypeRadioButtonNoteColor: colors.C1,
    serviceTypeRadioButtonEtaNoteColor: colors.BC10,
    serviceTypeRadioButtonNoteFontSize: fontSize.size12
  },
  button: {
    size: fontSize.size18,
    x: {
      color: colors.C2,
      backgroundColor: colors.BC12,
      hoverColor: colors.BC8a,
      borderBottom: 'transparent',
      borderRadius: '0.2rem',
      margin: padding.padding06
    },
    plus: {
      color: colors.C2,
      backgroundColor: colors.BC12,
      hoverColor: colors.BT2,
      borderBottom: 'transparent'
    },
    primary: {
      hoverColor: colors.C1a,
      hoverTextColor: colors.C2,
      borderBottom: 'none'
    },
    secondary: {
      hoverColor: colors.BC9,
      borderBottom: 'none'
    },
    checkout: {
      backgroundColor: {
        desktop: colors.C2,
        mobile: colors.C1
      },
      color: {
        desktop: colors.C1,
        mobile: colors.C2
      },
      fontFamily: 'Montserrat, sans-serif',
      fontSize: fontSize.size14,
      fontWeight: 700,
      letterSpacing: '0.1rem',
      width: '15rem',
      padding: '1.2rem',
      subTitle: {
        fontSize: fontSize.size10
      },
      margin: 0,
      border: `0.3rem solid ${colors.C1}`,
      borderBottom: `0.3rem solid ${colors.C1}`,
      disabled: {
        backgroundColor: colors.BC10,
        color: colors.C2,
        borderBottom: `0.3rem solid ${colors.C10}`,
        borderColor: colors.C10
      }
    }
  },
  //Menu
  menuPage: {
    menu: {
      width: '100%',
      maxWidth: '114rem',
      padding: padding.padding12,
      headerPadding: '3.6rem',
      backgroundColor: colors.BC11,
      mobileMenuBackground: colors.BC11,
      mobileMenuTextColor: colors.C1
    },
    closedMessage: {
      backgroundColor: colors.C11,
      color: colors.C2,
      margin: '2.4rem'
    },
    tabletView: {
      padding: padding.padding12
    },
    categoryGap: 0,
    nav: {
      display: {
        desktop: 'flex',
        tablet: 'flex'
      },
      width: 'auto',
      maxWidth: '78.8rem',
      height: '4rem',
      wrapperPadding: '0',
      padding: '1.2rem 2rem',
      fontSize: fontSize.size12,
      textTransform: 'uppercase',
      fontFamily: 'Montserrat, sans-serif',
      fontWeight: 700,
      lineHeight: '1.6rem',
      color: colors.C1,
      backgroundColor: colors.BC11
    },
    basket: {
      width: '34.2rem',
      fontSize: fontSize.size24,
      padding: '1.3rem',
      total: {
        fontSize: fontSize.size18,
        fontFamily: 'Montserrat, sans-serif',
        backgroundColor: colors.BC11,
        padding: '1.2rem 4rem',
        paddingSmall: '1.2rem',
        color: colors.C4,
        border: 0,
        letterSpacing: '0.2rem',
        textTransform: 'uppercase'
      }
    }
  },

  category: {
    borderBottom: `${colors.BD1} solid 0.2rem`,
    promotionOnTop: {
      display: 'flex'
    },
    header: {
      backgroundColor: 'transparent',
      name: {
        fontSize: {
          desktop: '2.8rem',
          mobile: fontSize.size22
        },
        textTransform: 'uppercase',
        letterSpacing: '0.2rem',
        lineHeight: 'auto'
      },
      icon: {
        top: '3.2rem',
        right: '2rem'
      },
      description: {
        height: '1.6rem',
        fontSize: fontSize.size12,
        textTransform: 'uppercase',
        padding: '1.4rem'
      }
    }
  },
  meal: {
    fontFamily: 'Montserrat, sans-serif',
    width: '50%',
    padding: '1rem',
    border: 'none',
    name: {
      fontSize: fontSize.size16
    },
    description: {
      fontSize: fontSize.size14,
      lineHeight: '2rem'
    },
    arrow: {
      display: 'none'
    },
    footer: {
      display: 'flex',
      height: '6rem'
    },
    addToBasket: {
      padding: 0,
      width: '8rem',
      fontSize: fontSize.size12,
      display: 'none'
    },
    price: {
      fontSize: fontSize.size16,
      color: colors.C4
    }
  },
  spinner: {
    c1: '#312c90',
    c2: '#4945a2',
    c3: '#6a71bb',
    c4: '#bdcaf9',
    margin: '-0.6rem'
  },

  promotion: {
    fontSize: fontSize.size16,
    fontWeight: 'normal',
    margin: {
      desktop: '0 2.2rem'
    }
  },

  // Confirmation page
  confirmationPage: {
    width: '114rem',
    backgroundColor: colors.BC5,
    linkColor: colors.C1,
    border: `${colors.BC11} solid 2.2rem`,
    trackerBlock: {
      width: '53rem',
      marginBottom: '3rem'
    },
    summaryBlock: {
      margin: '1.2rem',
      textTransform: 'uppercase',
      padding: padding.padding12
    },
    infoBlock: {
      justifyContent: 'flex-start'
    }
  },

  orderTracker: {
    iconColor: {
      active: colors.C1,
      inactive: colors.BC9
    },
    textColor: colors.C2,
    size: '6.4rem'
  },

  progressBar: {
    color: colors.C1,
    backgroundColor: colors.BC9
  },

  upselling: {
    direction: 'row',
    flexWrap: 'wrap',
    backgroundColor: colors.BC11,
    buttons: {
      padding: '0 2.4rem 1.2rem'
    }
  },
  checkoutPage: {
    color: colors.C4,
    backgroundColor: colors.BC11,
    bigLabelColor: colors.C6,
    deliveryAddressLabelColor: '#211c1d',
    inputErrorBackgroundColor: '#ffbcbc',
    inputTextColor: colors.C4,
    inputTextBackground: colors.BC10,
    inputTextBorderColor: '#e7e7e7',
    inputTextShadowColor: '#b4b4b4',
    smallTextColor: '#a6a6a6',
    requiredMessageColor: '#b94a48',
    paymentsDisclamerBackground: 'transparent',
    formErrorBackground: '#b77a7a',
    formErrorColor: colors.C2,
    deliveryFeeBackgroundColor: colors.BC13,
    linkColor: colors.C8,
    selectedDayBackground: colors.BC14,
    selectedDayColor: colors.C2,
    modalButtonMargin: padding.padding06,
    fontWeight: 'normal',
    margin: 0,
    borderRight: 0,
    textColor: colors.C4,
    payment: {
      backgroundColor: colors.BC10,
      title: {
        fontSize: '2rem'
      }
    }
  },
  tableBookingPage: {
    width: '53rem',
    color: colors.C5,
    backgroundColor: colors.BC11,
    offsetTop: 0,
    padding: '2.4rem',
    title: {
      fontWeight: 'bold'
    },
    subTitle: {
      fontSize: fontSize.size14
    }
  },
  basicPage: {
    width: '53rem',
    color: colors.C3a,
    minHeight: 'calc(100vh - 25rem)',
    backgroundColor: colors.BC11,
    linkColor: colors.C1a,
    offsetTop: 0,
    status: {
      lineHeight: '15rem',
      fontSize: '6rem',
      display: 'none'
    },
    sorry: {
      display: 'block'
    },
    fontSize: fontSize.size20
  },
  datePicker: {
    selected: {
      color: colors.C2,
      background: colors.C1
    }
  }
};

export const light = Object.assign({}, dark, templateTheme);



// WEBPACK FOOTER //
// ./styles/themes/light.js